module.exports = __webpack_public_path__ + "static/img/help_06_032.a6db9cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_06_032.jpg
// module id = 699
// module chunks = 140